import apiClient from "./apiClient";

// Life uses the same product-router shape as travel/pet/motor. It used to post
// to the legacy /data-sync and /get-case-data endpoints, whose handlers expect
// a different body ({ caseId, data } / { caseId, tableName }) — so every life
// save answered 400 and every load came back empty.
export const syncLifeData = async (caseId, body) =>
  (await apiClient.post("/life/sync", { case_id: caseId, insurance_type: "LIFE INSURANCE", ...body }))
    .data;

export const fetchLifeData = async (caseId) => (await apiClient.get(`/life/${caseId}`)).data;
